<div class="user-side-menu__nav">
  <ng-container *ngIf="isUserMenuOpen && isSideMenuToggle">
    <div class="user-menu-wrapper">
      <a (click)="navigate()" routerLinkActive="menu-active" class="menu_item" >
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <i class="icon-settings-wheel-24"></i>
            {{'Translation.Preferences' | translate}}
          </div>
        </div>
      </a>
      <a class="menu_item" *ngIf="termOfUseLink" [href]="termOfUseLink" target="_blank">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <i class="icon-terms-of-use-default-24" ></i>
            {{'Translation.Termsofuse' | translate}}
          </div>
        </div>
      </a>
      <a class="menu_item" *ngIf="privacyStatementLink" [href]="privacyStatementLink" target="_blank">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <i class="icon-privacy-statement-default-24" ></i>
            {{'Translation.Privacystatement' | translate}}
          </div>
        </div>
      </a>
      <div class="menu_item" (click)="logout()">
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center">
            <i class="icon-log-out-24"></i>
            {{'Translation.Logout' | translate}}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ul (click)="openUserMenu()" [ngClass]="isUserMenuOpen && isSideMenuToggle ? 'menu-active' : 'menu-inactive'">
    <li>
      <ng-container *ngIf="userData; else userDataFallBack">
        <div class="nav-icon">
          <app-avatar [email]="userData?.email" [userInitials]="userInitials"> </app-avatar>
        </div>
        <div *ngIf="isSideMenuToggle" class="user-info">
          <div class="user-name">{{ userData?.firstName }} {{ userData?.lastName }}</div>
          <div class="user-position">{{ userData?.shortTitle }}</div>
        </div>
      </ng-container>
      <span class="icon-arrow-down-12 chevron-down" *ngIf="!isUserMenuOpen && isSideMenuToggle"></span>
      <span class="icon-arrow-up-12 chevron-up" *ngIf="isUserMenuOpen && isSideMenuToggle"></span>
    </li>

    <!-- TODO: Remove this fallBack when userData is available -->
    <ng-template #userDataFallBack>
      <div class="nav-icon">
        <img [src]="user.image" alt="User image" />
      </div>
      <div *ngIf="isSideMenuToggle" class="user-info">
        <div class="user-name">{{ user.name }}</div>
        <div class="user-position">{{ user.position }}</div>
      </div>
    </ng-template>
  </ul>
</div>
